module.exports = __webpack_public_path__ + "img/pic3.50eb3b02.png";